import { Dialog } from "primereact/dialog";
import { JVInput } from "../../shared/JVInput";
import { Button } from "primereact/button";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { IEmptyVisa } from "./Table";
import { Fetch } from "../../shared/Fetch";
import { useEffect, useState } from "react";

interface IProps{
    singleData: IEmptyVisa,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

const schema=yup.object({
    visa_Name: yup.string().required("Visa Name is required"),
});

export const Form = (props: IProps) => {
    const [saveDis,setSaveDis] = useState(false);

    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<IEmptyVisa>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const onSubmit=(data: IEmptyVisa)=>{
        setSaveDis(true);
        saveToDB(data);
    }

    const saveToDB = async (data: any) => {
        const method = props.singleData.visa_Name != "" ? "PUT" : "POST";
        const message = props.singleData.visa_Name !="" ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch("Visa_Mast", method, data, null, props.toast);
        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
            setSaveDis(false);
        } else {
            setSaveDis(false);
        }
    }

    const onHide=()=>{
        props.hideDialog();
    }

    useEffect(()=>{
        reset(props.singleData);
    },[props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Visa" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput required label="Visa Name:" control={control} name="visa_Name" error={errors.visa_Name?.message} />
                <div className="col-12 md:col-12 flex gap-4">
                    <Button className="field col md:col" label="SAVE" type="submit" disabled={saveDis}></Button>
                    <Button className="field col md:col p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}